var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 12.8931C11.3737 12.8931 12.8928 11.3741 12.8928 9.50028C12.8928 7.62646 11.3737 6.10742 9.49991 6.10742C7.62609 6.10742 6.10706 7.62646 6.10706 9.50028C6.10706 11.3741 7.62609 12.8931 9.49991 12.8931Z",
    stroke: "#EFB800",
    strokeWidth: 1.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49996 6.10728V0.678711M12.8928 18.3216V16.2859H15.6071C15.967 16.2859 16.3122 16.1429 16.5667 15.8884C16.8213 15.6338 16.9642 15.2886 16.9642 14.9287V9.50014C16.9645 8.12411 16.5844 6.77479 15.8659 5.60125C15.1474 4.4277 14.1185 3.47561 12.8928 2.85014M6.1071 2.85014C4.88094 3.47523 3.85147 4.42717 3.13248 5.60074C2.41348 6.77432 2.03296 8.12383 2.03296 9.50014C2.03296 10.8764 2.41348 12.226 3.13248 13.3995C3.85147 14.5731 4.88094 15.525 6.1071 16.1501V18.3216",
    stroke: "#EFB800",
    strokeWidth: 1.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanicon2);
export default __webpack_public_path__ + "static/media/planicon2.9e1368d6dfb19e13c6c9a6c9373414da.svg";
export { ForwardRef as ReactComponent };